import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {Community} from '../_types/communities';
import {LocalStorageService} from './local-storage.service';

@Injectable()
export class AppTitlePrefix extends TitleStrategy {

    constructor(
        private titleService: Title,
        private localStorageService: LocalStorageService
    ) {
        super();
    }

    updateTitle(snapshot: RouterStateSnapshot): void {
        const pageTitle: string | undefined = this.buildTitle(snapshot);
        if (pageTitle) {
            const community: Community | null = this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
            const communityName: string | null = community?.name ?? this.getCommunityNameFromSubdomain();
            this.titleService.setTitle(`${communityName} - ${pageTitle}`);
        }
    }

    private toTitleCase(str: string): string {
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    private getCommunityNameFromSubdomain(): string | null {
        const hostname: string = window.location.hostname.split('.')[0];
        return this.toTitleCase(hostname);
    }
}
